<p class="title" *ngIf="!insideModal">
  {{ 'MANAGE_VACATIONS.BEFORE_REQUEST_VACATIONS_CHECK_1' | translate }}
  <b> {{ 'MANAGE_VACATIONS.' + selectedSeason.id | uppercase | translate | lowercase }}</b
  >{{ 'MANAGE_VACATIONS.BEFORE_REQUEST_VACATIONS_CHECK_2' | translate }}
</p>
<app-title-description-card
  [cardTitle]="'MANAGE_VACATIONS.VACATIONS_CRITERIA' | translate"
  [cardDescription]="criteria.generalInformation"
  [insideModal]="insideModal"
  *ngIf="criteria.generalInformation.length"></app-title-description-card>
<app-title-description-multiple-card
  [cardTitle]="'MANAGE_VACATIONS.CENTER_OBSERVATIONS' | translate"
  [values]="criteria.observations.general_observations"
  [insideModal]="insideModal"
  *ngIf="criteria.observations.general_observations.length"></app-title-description-multiple-card>
<app-title-description-multiple-card
  [cardTitle]="'MANAGE_VACATIONS.PARTICULAR_OBSERVATIONS' | translate"
  [values]="criteria.observations.particular_observations"
  [insideModal]="insideModal"
  *ngIf="criteria.observations.particular_observations.length"></app-title-description-multiple-card>
<app-title-description-card
  [cardTitle]="'MANAGE_VACATIONS.NOT_MATCH_WITH' | translate"
  [cardDescription]="criteria.commonHolidayUsers"
  [insideModal]="insideModal"
  *ngIf="criteria.commonHolidayUsers.length"></app-title-description-card>
<app-title-description-multiple-card
  [cardTitle]="('MANAGE_VACATIONS.VACATIONS_IN' | translate) + criteria.lastHolidays.year"
  [values]="mappedLastHolidays"
  [insideModal]="insideModal"
  [listStyle]="true"
  *ngIf="hasVacations"></app-title-description-multiple-card>
<app-title-description-multiple-card
  [cardTitle]="'MANAGE_VACATIONS.ALTERNATION_GUIDE' | translate"
  [values]="mappedAlternationGuide"
  [insideModal]="insideModal"
  [hasAction]="true"
  (click)="onAlternationGuideClick()"
  *ngIf="hasAlternationGuide"></app-title-description-multiple-card>
